import { gql } from 'urql';
import { MonetaryAmountFragment } from './supportTypesFragments';

export const SpendingCategoryEstimateFragment = gql`
  ${MonetaryAmountFragment}
  fragment SpendingCategoryEstimateFragment on SpendingCategoryEstimate {
    id
    householdID
    changeToken
    createdAt
    updatedAt
    dateTime
    notes
    categoryEstimates {
      category
      estimate {
        ...MonetaryAmountFragment
      }
    }
  }
`;
